<template>
  <div style="width: 100vw; height: 100vh; background: linear-gradient(#005a9f, #1899d6)">
      <div class="loginBox">
        <img class="loginBoxImg" src="/dist/logo_login.png" >
        <p class="labels" id="titulo" style="font-weight: 400; font-size: 23px; margin-bottom: 20px">Venttu Login</p>
        <form @submit.prevent>
          <p class="labels">USUARIO</p>
          <input class="inputbox login" :class="{'inputbox login error': errorUser}" type="email" v-model='usuario' >
          <p class="labels" style="margin-top: 10px">CONTRASEÑA</p>
          <input class="inputbox login" :class="{'inputbox login error': errorPass}" type="password" v-model='pass' >
          <p id="forgetPass" @click='btnOlvidePass'>Olvide mi contraseña</p>
          <div id="btnContainer">
            <button id="btnIngresar" @click="btnLogin"   >INGRESAR</button>
            <!-- <button id="btnRegistro" @click='btnRegistro'>REGISTRARME</button> -->
          </div>
        </form>
      </div>
  </div>
</template>


<script>
import axios from "axios";
import helper from '@helpers/helper.js';


export default {
  name: "Login",

  data() {
    return {
      usuario: "",
      pass: "",
      errorUser: false,
      errorPass: false
    }
  },


  methods: {

    btnLogin() {
      this.errorUser = false;
      this.errorPass = false;
      if (this.usuario.length < 6) {
        this.errorUser = true;
      }
      if (this.pass.length < 4) {
        this.errorPass = true;
      }
      if (!this.errorUser && !this.errorPass) {
        this.login();
      }
    },


    login() {

      this.$store.commit("loader/start");
      var header = { "Content-Type": "application/json" };

      var data = {
        Usuario: this.usuario.trim(),
        Password: this.pass.trim(),
      };

      this.$store.commit("user/saveEmail",this.usuario.trim());

      axios.post("/WebSalesLogin", data, header).then(
        response => {
          this.$store.commit("loader/stop");
          if (response.data.Code == 0)  
          {
            localStorage.setItem("lastActivity",Math.floor(Date.now() / 1000));
            if (response.data.Empresas != null) 
            {
              if (response.data.Empresas.length == 1)
              {
                // si solo pertenece a una empresa
                helper.getEmpresa(response.data,response.data.Empresas[0],this.configCallback)
              }
              else if (response.data.Empresas.length > 1)
              {
                // pantalla select empresa 
                this.$store.commit("user/saveEmpresas",response.data.Empresas);
                this.$store.commit("user/saveResponseLogin",response.data);
                this.$router.push({ name: "empresas" })
              }
            }
           }
          else
          {
            this.$store.commit('user/deleteUser');
            this.$store.commit('user/deleteCliente');
            this.$store.commit('user/deleteEmpresas');
            this.$store.commit('user/deleteResponseLogin');
            this.$store.commit('user/deleteImagenLogo'); 
            var obj = {
              txt: response.data.Message,
              txtBtnCancel: "",
              txtBtnOk: "Aceptar",
              fCancel: null,
              fOk: null
            };
            this.$store.commit("popup/open", obj);
          }
        },
        error => {
          this.$store.commit("loader/stop");
          console.log(error);
          this.$store.commit('user/deleteUser');
          this.$store.commit('user/deleteCliente');
          this.$store.commit('user/deleteEmpresas');
          this.$store.commit('user/deleteResponseLogin');
          this.$store.commit('user/deleteImagenLogo'); 
        }
      );
    },


    configCallback(){

       this.$access(this.$store.state.user.usuario.EsEmpleado ? ['seller', 'user'] : 'user');

       // solicita datos solo cuando no es un empleado
       if (!this.$store.state.user.usuario.EsEmpleado) 
       {
         this.getDatosCliente();
       }
       else 
       {
         this.$router.push({ name: "clientes" })
       }
    },


    getDatosCliente() {
      axios
        .get("/WebSalesCliente?ClienteId=" + this.$store.state.user.usuario.ClienteId, {
          headers: {
              Token:        this.$store.state.user.usuario.Token,
              ClientSecret: this.$store.state.entorno.clientSecret,
              EmpresaId:    this.$store.state.entorno.idEmpresa
          }
        })
        .then(
          response => {
            if (response.data.Code == 0) 
            {
              this.$store.commit("user/saveCliente", response.data);
              this.$router.push({ name: "home" });
            }
            else
            {
              this.$store.commit("loader/stop");
              alert(response.data.Message);
              this.$store.commit('user/deleteUser');
              this.$store.commit('user/deleteCliente');
              this.$store.commit('user/deleteEmpresas');
              this.$store.commit('user/deleteResponseLogin');
              this.$store.commit('user/deleteImagenLogo'); 
            }
          },
          error => {
            this.$store.commit("loader/stop");
            console.log(error);
            this.$store.commit('user/deleteUser');
            this.$store.commit('user/deleteCliente');
            this.$store.commit('user/deleteEmpresas');
            this.$store.commit('user/deleteResponseLogin');
            this.$store.commit('user/deleteImagenLogo'); 
          }
        );
    },

    btnRegistro() {
      this.$router.push({ name: "registro" });
    },

    btnOlvidePass() {
      if (this.usuario.length > 5) {
        var obj = {
          txt:
            "Se le enviara una nueva contraseña al email indicado en el campo usuario",
          txtBtnCancel: "Cancelar",
          txtBtnOk: "Aceptar",
          fCancel: null,
          fOk: this.enviarPass
        };
        this.$store.commit("popup/open", obj);
      } else {
        var obj = {
          txt:
            "Debe ingresar su usuario para poder enviarle su nueva contraseña",
          txtBtnCancel: "",
          txtBtnOk: "Aceptar",
          fCancel: null,
          fOk: null
        };
        this.$store.commit("popup/open", obj);
      }
    },

    enviarPass() {
      this.$store.commit("loader/start");
      var bdParam = {
        Usuario: this.usuario,
        ClientSecret: this.$store.state.entorno.clientSecret,
        EmpresaId:    this.$store.state.entorno.idEmpresa
      };
      axios.put("/WebSalesContrasenia", bdParam).then(
        response => {
          this.$store.commit("loader/stop");
          if (response.data.Code == 0) {
            var obj = {
              txt: "La nueva contraseña ha sido enviada a su email",
              txtBtnCancel: "",
              txtBtnOk: "Aceptar",
              fCancel: null,
              fOk: null
            };
            this.$store.commit("popup/open", obj);
          } else if (response.data.Code == 99) {
            alert(response.data.Message);
          } else {
            console.log(">>>>" + response.data.Message);
          }
        },
        error => {
          console.log(error);
          alert(error);
        }
      );
    }
  },

  mounted() {
    this.$store.commit("loader/stop");
    if (this.$store.state.user.usuario != null)
    {
      var lastActivity  = Number(localStorage.getItem('lastActivity') || 0) 
      var currentMillis = Number(Math.floor(Date.now() / 1000))
      var sesionTime    = lastActivity + Number(process.env.EXPIRATION_SESION)

      if (sesionTime >= currentMillis)
      {
        this.$store.commit("entorno/reload",true);
        if (this.$store.state.user.usuario.EsEmpleado) 
        {
          this.$access("seller");
          if (this.$store.state.user.cliente != null)
          {
            this.$router.push({ name: "home" })
          }
          else
          {
            this.$router.push({ name: "clientes" })
          }
        }
        else if (this.$store.state.user.cliente)
        {
          this.$access("user");
          this.$router.push({ name: 'home' });
        }
      }
      else
      {
        this.$access("any");
        this.$store.commit('user/deleteUser');
        this.$store.commit('user/deleteCliente');
        this.$store.commit('user/deleteEmpresas');
        this.$store.commit('user/deleteResponseLogin');
        this.$store.commit('user/deleteImagenLogo'); 
        this.$store.commit("pedido/delete");
      }
    }

  }


};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

.loginBox {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 350px;
  width: 90vw;
  height: 350px;
  padding: 20px;
  border-radius: 15px;
  box-sizing: border-box;
  background: #ffffff;
}

.loginBoxImg {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  overflow: hidden;
  position: absolute;
  top: calc(-100px / 2);
  left: calc(50% - 50px);
}

.labels {
  margin: 0;
  padding-bottom: 5px;
  font-weight: 500;
  font-size: 10px;
  color: #5c666f;
}

#titulo {
  margin-top: 50px;
  padding: 0, 0, 20px;
  text-align: center;
  font-size: 20px;
}

.inputbox.login {
  max-width: 305px;
  width: 75vw;
  padding-left: 5px;
  padding-right: 5px;
  margin-bottom: 10px;
}

.inputbox.login.error {
  border-color: #ff0000;
}

#forgetPass {
  text-align: center;
  font-weight: 400;
  font-size: 12px;
  color: #4969b2;
}

#btnContainer {
  margin-top: 30px;
  text-align: center;
}

input[type="submit"] {
  height: 30px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 20px;
  border-style: solid;
  border: none;
}

#btnRegistro {
  width: 100px;
  height: 30px;
  margin-bottom: 20px;
  margin-right: 5px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 20px;
  border-style: solid;
  border-color: #5c666f;
  border-width: 2px;
  text-align: center;
  color: #5c666f;
  background: #ffffff;
  outline: none;
}

#btnIngresar {
  margin-bottom: 20px;
  margin-left: 5px;
  height: 30px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 20px;
  border-style: solid;
  border: none;
  text-align: center;
  width: 80px;
  background: #005a9f;
  color: #ffffff;
  border-width: 1px;
  border: 2px solid #005a9f;
  outline: none;
}

#btnRegistro:hover {
  cursor: pointer;
}
#btnIngresar:hover {
  cursor: pointer;
}
#forgetPass:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/views/login/login.vue